(function() {
  'use strict';

  angular.module('ringbaPortal').component('accountSettingToggle', {
    bindings: {
      accountSettingCurrentValueOverride: '<',
      setting: '<',
      settingDefaultValue: '<',
      settingName: '<',
      settingEnabled: '<',
      settingEnabledLabel: '@',
      settingDisabled: '<',
      settingDisabledLabel: '@',
      settingGlobalLabel: '@',
      settingGlobalExternalLinkOverride: '@',
      settingGlobalHideExternalLink: '<',
      settingCustomValueLabelMapping: '<',
      toggleValueChanged: '&',
      accountSetting: '<'
    },
    controller: AccountSettingToggleController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/account-setting-toggle/account-setting-toggle.view.html'
  });

  function AccountSettingToggleController(
    $filter
  ) {
    'ngInject';

    const vm = this;
    vm.setToggle = setToggle;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.GLOBAL = 'global';
    vm.ENABLE = 'enable';
    vm.DISABLE = 'disable';

    vm.globalLabel;

    function onInit() {
      _loadGlobalLabel();
    }

    function onChanges(changesObj) {
      if (changesObj) {
        if (changesObj.setting) {
          vm.selectedValue = _getSelectedValue(changesObj.setting.currentValue);
        }

        if (changesObj.accountSettingCurrentValueOverride) {
          vm.currentGlobalSetting = _getCurrentGlobalValue(vm.accountSettingCurrentValueOverride);
        } else if (changesObj.accountSetting && vm.accountSetting) {
          vm.currentGlobalSetting = _getCurrentGlobalValue(vm.accountSetting[vm.settingName]);
        }

        if (changesObj.settingGlobalLabel) {
          _loadGlobalLabel();
        }
      }
    }

    function onDestroy() {
      const extLinkTooltip = document.querySelector('.tooltip');

      if (extLinkTooltip) {
        extLinkTooltip.remove();
      }
    }

    function setToggle() {
      let newSettingValue = null;

      if (vm.selectedValue === vm.ENABLE) {
        newSettingValue = vm.settingEnabled;
      } else if (vm.selectedValue === vm.DISABLE) {
        newSettingValue = vm.settingDisabled;
      }

      vm.toggleValueChanged()(newSettingValue);
    }

    function _getSelectedValue(setting) {
      if (typeof setting == 'boolean') {
        if (setting === vm.settingEnabled) {
          return vm.ENABLE;
        } else {
          return vm.DISABLE;
        }
      } else if (typeof setting == 'string') {
        if (setting == '') {
          return vm.DISABLE;
        } else if (setting) {
          return vm.ENABLE;
        } else {
          return vm.GLOBAL;
        }
      } else {
        return vm.GLOBAL;
      }
    }

    function _getCurrentGlobalValue(globalSetting) {
      if (globalSetting == 'null') {
        globalSetting = _getSettingDefaultValue();
      }

      if (globalSetting == vm.settingEnabled) {
        return vm.settingEnabledLabel;
      }

      if (vm.settingCustomValueLabelMapping && vm.settingCustomValueLabelMapping[globalSetting]) {
        return vm.settingCustomValueLabelMapping[globalSetting];
      }

      return vm.settingDisabledLabel;
    }

    function _getSettingDefaultValue() {
      if (vm.settingDefaultValue !== undefined) {
        return vm.settingDefaultValue;
      }

      return vm.settingDisabled;
    }

    function _loadGlobalLabel() {
      if (vm.settingGlobalLabel) {
        vm.globalLabel = vm.settingGlobalLabel;
      } else {
        vm.globalLabel = $filter('translate')('ACCOUNT_SETTING_TOGGLE_GLOBAL');
      }
    }
  }
})();
